import { OpenAPI as OpenAPIGeocoding } from '@/services/api-geocoding';
import { OpenAPI as OpenAPIPostProcessing } from '@/services/api-postprocessing';
import { OpenAPI as OpenAPIRouting } from '@/services/api-routing';

OpenAPIGeocoding.BASE = import.meta.env.VITE_GEOCODING_URL || '';
OpenAPIRouting.BASE = import.meta.env.VITE_ROUTING_URL || '';
OpenAPIPostProcessing.BASE = import.meta.env.VITE_POSTPROCESSING_URL || '';
